import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import FileBase64 from "react-file-base64";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import addRataStatus from "../services/addRataStatus";
import saveFile from "../services/saveFile";
import Cookies from "universal-cookie";
import uuid from "react-uuid";
import Constants from "../utils/consts";
import Button from "./Button";
import fileImage from "../images/file.png";
import MyDatePicker from "./DatePickerIta";
import $ from "jquery";
import moment from "moment";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import ImageSilentInput from "./ImageSilentInput";

export default class RataDaVerificareWidget extends React.Component {
	constructor(props) {
		super(props);

		this.rataDateRef = React.createRef();
		this.importoRef = React.createRef();
		this.importo = 0;

		this.options = [];
		this.options.push({ value: "NON PAGATA", label: "NON PAGATA" });
		this.options.push({ value: "DA VERIFICARE", label: "DA VERIFICARE" });
		this.options.push({ value: "PAGATA", label: "PAGATA" });
		this.files = [];
		this.newFiles = [];
		this.deletedFiles = [];
		this.newNote = undefined;

		this.state = {
			option: this.option,
		};
	}

	onContentStateChange = contentState => {
		this.savedEnabled = true;
		console.log("as HTML:", draftToHtml(contentState));
		this.setState({ contentState });
	};

	componentDidMount() {
		this.option = this.options.find(o => o.value == this.props.status);
		this.setState({
			option: this.option,
		});
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.rata) != JSON.stringify(this.props.rata)) {
			this.option = this.options.find(o => o.value == this.props.status);
			this.importo = this.props.rata.importo;
			this.data = this.props.rata.data;
			this.setState({ option: this.option, note: this.props.rata.note });
		}
		this.newFiles = [];
		this.deletedFiles = [];
		this.newNote = undefined;
	}

	render() {
		if (this.props.rata == undefined) return null;

		this.files = [];
		var tempArr = this.props.rata.files ? this.props.rata.files.split(";") : [];
		for (var t of tempArr) if (t != "" && this.deletedFiles.indexOf(t) == -1) this.files.push(t);
		for (var t of this.newFiles) if (t != "" && this.deletedFiles.indexOf(t) == -1) this.files.push(t.src);

		const that = this;
		const rataDataFormatted = moment(this.data, "DD-MM-yyyy").format("yyyy-MM-DD");

		return (
			<div key={Math.random()} style={{ display: this.props.show == true ? "block" : "none" }}>
				<div style={container}>
					<div style={mainClass}>
						<div
							style={closeBtn}
							onClick={() => {
								this.setState({ visible: false });
								this.props.onClose();
							}}
						>
							X
						</div>

						<div style={{ paddingLeft: "5px" }}>
							{this.props.rata.studente && (
								<div>
									Nome: {this.props.rata.studente.nome + " " + this.props.rata.studente.cognome}
								</div>
							)}
							<div>Corso: {this.props.rata.corso.name}</div>
							<MyDatePicker
								ref={this.rataDateRef}
								value={rataDataFormatted}
								onChange={data => {
									this.data = data;
								}}
							/>
							<TextInput
								ref={this.importoRef}
								name="Importo"
								value={this.importo}
								onChange={text => {
									this.importo = text;
								}}
							/>
						</div>

						{this.props.isStudent == true && (
							<>
								<SelectInput
									key={Math.random()}
									value={this.state.option}
									name={"Stato:"}
									options={this.options}
									isMulti={false}
									onChange={option => {
										this.setState({
											option: option,
										});
									}}
								/>

								<TextInput
									key={Math.random()}
									name={"Note"}
									value={this.newNote ? this.newNote : this.state.note}
									onChange={text => {
										this.newNote = text;
									}}
								/>

								<div style={{ width: "100%", display: "inline-flex", overflow: "scroll" }}>
									{this.files.map(file => {
										return (
											<div>
												<a target="_blank" href={file}>
													<img src={fileImage} />
												</a>
												<div
													style={{
														position: "relative",
														top: "-90px",
														left: "30px",
														cursor: "pointer",
													}}
													onClick={() => {
														if (window.confirm("Eliminare l'immagine?") == false) return;
														this.deletedFiles.push(file);
														this.setState({});
													}}
												>
													X
												</div>
											</div>
										);
									})}
								</div>
								<ImageSilentInput
									name={"Aggiungi documento"}
									key={Math.random()}
									value={this.state.imageToLoad}
									onChange={async base64 => {
										const photoId = uuid();
										const cookies = new Cookies();
										const token = cookies.get("token", { path: "/" });
										const username = cookies.get("username", { path: "/" });

										let retPhotoObj = await saveFile(username, token, photoId, base64);
										const fileName = "http://" + Constants.mainUrl + retPhotoObj.name;
										this.newFiles.push({
											id: photoId,
											src: fileName,
											width: 1,
											height: retPhotoObj.height / retPhotoObj.width,
										});

										this.setState({});
									}}
								/>
							</>
						)}

						<Button
							callback={async () => {
								var filesString = "";
								for (var str of this.files) {
									if (filesString != "") filesString = filesString + ";";
									filesString = filesString + str;
								}

								var note = this.newNote != undefined ? this.newNote : this.state.note;
								var rataDate = this.rataDateRef.current.getDate();
								rataDate = moment(rataDate).format("DD-MM-yyyy");

								const cookies = new Cookies();
								const username = cookies.get("username", { path: "/" });
								const token = cookies.get("token", { path: "/" });
								var rata = this.props.rata;

								rata.id_corso = rata.corso.id;
								rata.id_studente = rata.studente.id;
								rata.importo = this.importo;
								rata.data = rataDate;
								rata.note = note;
								rata.files = filesString;
								rata.status = this.state.option.value;

								let res = await addRataStatus(
									username,
									token,
									rata.corso.id,
									rata.studente.id,
									rataDate,
									this.importo,
									this.state.option.value,
									filesString,
									note
								);
								if (res.result == "ok") {
									this.props.onClose();
								} else {
									alert("Si è verificato un errore durante il salvataggio della rata.");
								}
							}}
							title="SALVA"
						></Button>
					</div>
				</div>
			</div>
		);
	}
}

const mainClass = {
	position: "fixed",
	top: "25%",
	left: "25%",
	width: "50%",
	border: "1px solid black",
	background: "#ffffff",
	padding: "2%",
	height: "400px",
	overflow: "scroll",
};

const container = {
	position: "fixed",
	width: "100%",
	height: "100%",
	top: 0,
	left: 0,
	background: "#ffffff88",
	zIndex: 999,
};

const title = {
	position: "relative",
	textAlign: "center",
	width: "100%",
	fontWeight: "bold",
};

const bodyMsg = {
	border: "1px solid black",
	height: "200px",
};

const inputText = {
	width: "300px",
	padding: "10px",
};

const closeBtn = {
	position: "absolute",
	right: "1%",
	top: "1%",
	cursor: "pointer",
};
